import React, { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./Datepicker.css"
import _ from 'lodash';
import moment from 'moment';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

class Datepicker extends React.Component {
  state = {
    username: ''
  }

  onChangeDatepicker = (e) => {
    this.setState({ username: e.target.value })
  };

  render() {
    const attributes = this.props;
    const years = _.range(1950, 2099, 1);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return (
      <div className="datepicker-container position-relative">

        <DatePicker
          renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
            <div
              style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button className="datepicker-nav-btn" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                <ChevronLeft size={14} />
              </button>

              <select
                className="datepicker-select"
                value={date.getFullYear()}
                onChange={({ target: { value } }) => changeYear(Number(value))}
              >
                {years.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>

              <select
                className="datepicker-select"
                value={months[date.getMonth()]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
              >
                {months.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>

              <button className="datepicker-nav-btn" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                <ChevronRight size={14} />
              </button>

              <button
                type="button"
                className="datepicker-clear-btn"
                onClick={() => attributes.onChange(null)}
              >
                Clear
              </button>
            </div>
          )}

          className={`form-control datepicker-input ${attributes.className ? attributes.className : ''} ${attributes.errorClass ? 'is-invalid' : ''}`}
          selected={attributes.value}
          onChange={attributes.onChange}
          dateFormat={attributes.dateFormat}
          placeholderText={attributes.placeholderText}
        />
        <Calendar className="calendar-icon" size={18} />

      </div>


    )
  };

}


export default Datepicker;